export var SDKErrorCode;
(function (SDKErrorCode) {
    SDKErrorCode["MissingApiKey"] = "MISSING_API_KEY";
    SDKErrorCode["ModalNotReady"] = "MODAL_NOT_READY";
    SDKErrorCode["MalformedResponse"] = "MALFORMED_RESPONSE";
    SDKErrorCode["InvalidArgument"] = "INVALID_ARGUMENT";
    SDKErrorCode["ExtensionNotInitialized"] = "EXTENSION_NOT_INITIALIZED";
    SDKErrorCode["IncompatibleExtensions"] = "INCOMPATIBLE_EXTENSIONS";
})(SDKErrorCode || (SDKErrorCode = {}));
export var SDKWarningCode;
(function (SDKWarningCode) {
    SDKWarningCode["SyncWeb3Method"] = "SYNC_WEB3_METHOD";
    SDKWarningCode["DuplicateIframe"] = "DUPLICATE_IFRAME";
    SDKWarningCode["ReactNativeEndpointConfiguration"] = "REACT_NATIVE_ENDPOINT_CONFIGURATION";
    SDKWarningCode["DeprecationNotice"] = "DEPRECATION_NOTICE";
})(SDKWarningCode || (SDKWarningCode = {}));
export var RPCErrorCode;
(function (RPCErrorCode) {
    // Standard JSON RPC 2.0 Error Codes
    RPCErrorCode[RPCErrorCode["ParseError"] = -32700] = "ParseError";
    RPCErrorCode[RPCErrorCode["InvalidRequest"] = -32600] = "InvalidRequest";
    RPCErrorCode[RPCErrorCode["MethodNotFound"] = -32601] = "MethodNotFound";
    RPCErrorCode[RPCErrorCode["InvalidParams"] = -32602] = "InvalidParams";
    RPCErrorCode[RPCErrorCode["InternalError"] = -32603] = "InternalError";
    // Custom RPC Error Codes
    RPCErrorCode[RPCErrorCode["MagicLinkFailedVerification"] = -10000] = "MagicLinkFailedVerification";
    RPCErrorCode[RPCErrorCode["MagicLinkExpired"] = -10001] = "MagicLinkExpired";
    RPCErrorCode[RPCErrorCode["MagicLinkRateLimited"] = -10002] = "MagicLinkRateLimited";
    RPCErrorCode[RPCErrorCode["MagicLinkInvalidRedirectURL"] = -10006] = "MagicLinkInvalidRedirectURL";
    RPCErrorCode[RPCErrorCode["UserAlreadyLoggedIn"] = -10003] = "UserAlreadyLoggedIn";
    RPCErrorCode[RPCErrorCode["UpdateEmailFailed"] = -10004] = "UpdateEmailFailed";
    RPCErrorCode[RPCErrorCode["UserRequestEditEmail"] = -10005] = "UserRequestEditEmail";
})(RPCErrorCode || (RPCErrorCode = {}));
//# sourceMappingURL=exception-types.js.map